import { render } from "./NcToggle.vue?vue&type=template&id=418807d4&scoped=true"
import script from "./NcToggle.vue?vue&type=script&lang=js"
export * from "./NcToggle.vue?vue&type=script&lang=js"

import "./NcToggle.vue?vue&type=style&index=0&id=418807d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-418807d4"]])

export default __exports__